<template>
  <div class="homepage">
    <!-- 轮播图 -->
    <div class="backimg">
      <img
        :src="img"
        alt=""
        style=" width: 100%;height: 100%;vertical-align:middle;object-fit:contain;"
      />
      <div class="betweencenter">
        <div class="real">
            <div class="tis bigcolor">{{$t('main.title')}}</div>
          <div class="tixt middlecolorc">
            {{$t('main.text')}}
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="vedio pt">
        <div class="video_textl">
          <div class="text_title colors" :title="this.$t('main.texttitle')">
           • {{ this.$t('main.texttitle') | ellipsis }}
           <div class="colors" style="margin-top:20px;" :title="this.$t('main.texttitles')">
             • {{ this.$t('main.texttitles') | ellipsis }}
           </div>
          </div>
        </div>
        <vedio :vedios="vediolist"></vedio>
      </div>
      <!-- 产品介绍 -->
      <div class="pt">
        <h1>{{$t('main.product')}}</h1>
        <div class="bot">Product Presentation</div>
        <div style="margin-bottom:60px;">
          <img src="../../assets/img/main/biaoji.png" alt="" />
        </div>
      </div>
    </div>
    <div class="contents">
      <div class="navs">
        <div
          v-for="(item, it) in $t('main.textlist')"
          :key="it"
          class="list"
          @mouseover="mouseOver(it)"
          :class="
            item.name == 'MSP'|| item.name =='MSP'
              ? 'dciback'
              : item.name == '雲專線'|| item.name =='SD-Cloud'
              ? 'cloudback'
              : item.name == '定向加速'|| item.name =='DA'
              ? 'jsback'
              : item.name == 'SD-WAN'|| item.name =='SD-WAN'
              ? 'sdnback'
              : ''
          "
        >
          <div class="jiesh" :class="selected == it ? 'listback' : ''">
            <div style="height:105px;">
               <img :src="item.img" alt="" class="navimg" />
            </div>
            <p class="tixt">{{ item.name }}</p>
            <div :class="selected == it ? 'active' : 'none'">
              <p align="left" class="fonts pds">
                {{ item.title | ellipsisprot }}
              </p>
              <el-button
                plain
                style="margin-top:26px;"
                @click="productTap(item.type)"
                >{{ item.btn }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 客户案例 -->
    <div class="main">
      <div class="pt">
        <h1>
         {{$t('main.case')}}
        </h1>
        <div class="bot">Customer case</div>
        <div style="margin-bottom:60px;">
          <img src="../../assets/img/main/biaoji.png" alt="" />
        </div>
      </div>
      <caseList :caselist="$t('main.caselist')"></caseList>
    </div>
    <!-- 网骨图介绍 -->
    <div class="mapback">
      <div style="height:30px;"></div>
      <h1>
        {{$t('main.create')}}
      </h1>
      <div class="bot" style="color:#fff;">Create unlimited connection</div>
      <div>
        <img src="../../assets/img/main/biaoji.png" alt="" />
      </div>
      <mapWorld ref="initEcharts"></mapWorld>
    </div>
    <!-- 合作伙伴 -->
    <div class="main">
      <div class="pt">
        <h1>{{$t('main.partner')}}</h1>
        <div class="bot">Insist on cooperation and service first</div>
        <div style="margin-bottom:72px;">
          <img src="../../assets/img/main/biaoji.png" alt=""/>
        </div>
      </div>
      <div class="partnercontent">
        <div class="headerTitle">
          <div
            class="fontw"
            :class="tapflag ? 'active' : 'one'"
            @click="tapphone"
          >
            {{$t('main.serve')}}
          </div>
          <div
            class="fontw"
            :class="tapflags ? 'actives' : 'two'"
            @click="tapemail"
          >
            {{$t('main.join')}}
          </div>
        </div>
        <div class="formsign" v-if="tapflag">
          <el-carousel :interval="3000" height="311px">
            <el-carousel-item v-for="(item, is) in carousel" :key="is">
              <img :src="item.img" alt="" style=" width: 100%;height: 100%;vertical-align: middle;"/>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="formsign" v-else>
          <el-carousel :interval="3000" height="311px">
            <el-carousel-item v-for="(item, is) in carousels" :key="is">
              <img :src="item.img" alt="" style=" width: 100%;height: 100%;vertical-align: middle;"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vedio from "../../components/vediodetails";
import caseList from "../../components/caseList";
import mapWorld from "../../components/mapWorld";
export default {
  components: {
    vedio,
    caseList,
    mapWorld
  },
  data() {
    return {
      lang:'zh',
      img: require("../../assets/img/main/lun2.png"),
      carousel: [
        {
          img: require("../../assets/img/main/parner.png")
        }
      ],
      carousels: [
        {
          img: require("../../assets/img/main/parner1.png")
        },
        {
          img: require("../../assets/img/main/parner2.png")
        }
      ],
      vediotitle: "视频介绍",
      headerline: "标题",
      texttitles:
        "基于行业特性，天弛网络以安全为先，稳定为本，整合行业资源，为各行业提供针对性解决方案，布局生态网络平台",
      texttitle:
        "天弛网络致力于打造国内领先的生态网络服务，坚持以客户至上、创新务实、不忘初心、以诚为本的企业价值观",
      textlist: [
        {
          name: "DCI互联",
          img: require("../../assets/img/main/DCI.png"),
          title:
            "高速、安全、稳定的专线连接服务，基于天弛网络SDN网络满足网内不同地域DC-DC的互联需求。",
          btn: "了解更多",
          type: 1
        },
        {
          name: "云专线",
          img: require("../../assets/img/main/cloud.png"),
          title:
            "提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN平台满足网内不同地域POP节点-公有云、公有云-公有云的互联需求。",
          btn: "了解更多",
          type: 2
        },
        {
          name: "定向加速",
          img: require("../../assets/img/main/JS.png"),
          title:
            "定向加速是天弛网络提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN平台满足网内不同地域定向加速需求",
          btn: "了解更多",
          type: 3
        },
        {
          name: "SD-WAN",
          img: require("../../assets/img/main/SD-WAN.png"),
          title:
            "提供的高速、安全、稳定的连接服务，基于天弛网络SD-WAN网络满足网内不同地域互联需求。",
          btn: "了解更多",
          type: 4
        }
      ],
      caselist: [
        {
          name: "DCI互联产品案例",
          img: require("../../assets/img/main/DCIcase.png"),
          title: "基于天弛SDN高可用网络满足客户不同数据中心的互联需求",
          type: 1
        },
        {
          name: "云专线产品案例",
          img: require("../../assets/img/main/cloudCase.png"),
          title: "帮助企业快速构建高质量的连接公有云的专有网络",
          type: 2
        },

        {
          name: "定向加速产品案例",
          img: require("../../assets/img/main/speedCase.png"),
          title: "基于天弛SDN高可用网络平台满足客户不同定向加速的需求",
          type: 3
        },
        {
          name: "SD-WAN产品案例",
          img: require("../../assets/img/main/SD-WANcase.png"),
          title:
            "基于天弛SD-WAN高可用网络满足客户总部与分支机构的互联需求，帮助企业快速组网",
          type: 4
        }
      ], //产品介绍
      vediolist: {
        vediotile: require("../../assets/movie/bglb.mp4"),
        width: "80%",
        height: "80%"
      },
      vediocase: {
        vediotile: require("../../assets/movie/bglb.mp4"),
        width: "100%",
        height: ""
      },
      tabPosition: "left",
      current: "DCI",
      show: false,
      selected: "",
      tapflag: true,
      tapflags: false,
      // 图片父容器高度
      bannerHeight: 0,
      // 浏览器宽度
      screenWidth: 0,
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.$refs.initEcharts.initEcharts();
    });
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 200) {
        return value.slice(0, 201) + "...";
      }
      return value;
    },
    ellipsisprot(value) {
      if (!value) return "";
      if (value.length > 35) {
        return value.slice(0, 35) + "...";
      }
      return value;
    }
  },
  methods: {
    mouseOver(it) {
      switch (it) {
        case 0:
          this.selected = it;
          break;
        case 1:
          this.selected = it;
          break;
        case 2:
          this.selected = it;
          break;
        default:
          this.selected = it;
          break;
      }
    },
    setSize: function() {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (592 / 1920) * this.screenWidth;
    },
    tabSelect(name) {
      this.current = name;
    },
    caseTap() {
      this.$router.push({
        name: "case"
      });
    },
    productTap(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: "product"
          });
          break;
        case 2:
          this.$router.push({
            name: "product2"
          });
          break;
        case 3:
          this.$router.push({
            name: "product3"
          });
          break;
        default:
          this.$router.push({
            name: "product4"
          });
          break;
      }
    },
    tapphone() {
      this.tapflag = true;
      this.tapflags = false;
    },
    tapemail() {
      this.tapflag = false;
      this.tapflags = true;
      console.log(this.tapflags);
    }
  }
};
</script>
<style lang="scss">
.homepage {
  width: 100%;
  height: auto;
  .backimg {
    position: relative;
    overflow: hidden;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 390px;
          margin-top: 36px;
          line-height: 24px;
          letter-spacing: 1px;
        }
      }
    }
  }

  .main {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    .vedio {
      display: flex;
      width: 100%;
      .video_textl {
        box-sizing: border-box;
        text-align: left;
        width: 43%;
        padding: 60px;
        margin-right: 20px;
        .disp {
          display: flex;
          justify-content: left;
          .backs {
            width: 240px;
            height: 89px;
            line-height: 70px;
            font-size: 26px;
            color: #ffffff;
            text-align: center;
            display: inline-block;
            background: url("../../assets/img/main/vedio.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          .backg {
            display: inline-block;
            width: 240px;
            line-height: 70px;
            font-size: 26px;
            color: #248f47;
            text-align: center;
            height: 70px;
            background: url("../../assets/img/main/vedios.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
        }

        .textli {
          font-size: 18px;
          font-weight: 700;
          color: #333333;
          margin-top: 16px;
        }
        .text_title {
          text-align: left;
          margin-top: 20px;
          line-height: 27px;
        }
      }
    }
  }
  .el-carousel {
    width: 100%;
  }
  .el-carousel__indicators--horizontal {
    display: none;
  }
  .el-carousel__indicator.is-active button {
    background-color: #248f47;
  }
  // 产品介绍
  .contents {
    width: 100%;
    height: 500px;
    background: url("../../assets/img/main/probackg.png") no-repeat center
      center;
    background-size: 100% 100%;
    .navs {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .list {
        width: 300px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .jiesh {
          text-align:center;
          .tixt {
            font-size: 30px;
            color: #fff;
            margin-top: 30px;
            margin-bottom: 50px;
          }
          .pds {
            padding: 0 30px;
          }
          .active {
            display: block;
            transition: all 1.4s;
          }
          .none {
            display: none;
          }
        }
        .listback {
          background-color: #248f47;
          opacity: 0.6;
          height: 100%;
          padding-top: 80px;
          box-sizing: border-box !important;
        }
      }
      .dciback {
        background: url("../../assets/img/main/DCIback.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .cloudback {
        background: url("../../assets/img/main/cloudback.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .jsback {
        background: url("../../assets/img/main/JSback.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .sdnback {
        background: url("../../assets/img/main/SD-WANback.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
    }
  }
  // 合作伙伴
  .partnercontent {
    width: 100%;
    margin-bottom: 80px;
    .headerTitle {
      width: 100%;
      height: 50px;
      text-align: center;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 18px;
      color: #333333;
      .one {
        width: 20%;
        height: 100%;
        font-size: 18px;
      }
      .two {
        width: 20%;
        height: 100%;
        font-size: 18px;
      }
      .active {
        width: 20%;
        height: 100%;
        background: url("../../assets/img/main/cursor.png") no-repeat bottom
          center;
        background-size: 186px 11px;
        font-size: 18px;
      }
      .actives {
        width: 20%;
        height: 100%;
        background: url("../../assets/img/main/cursor.png") no-repeat bottom
          center;
        background-size: 186px 11px;
        font-size: 18px;
      }
    }
    .formsign {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .mapback {
    background: url("../../assets/img/main/world.png") no-repeat center center;
    // background-image: radial-gradient(rgb(23, 154, 127), rgb(8, 42, 40));
    background-size: 100% 100%;
    margin-top: 80px;
    h1 {
      color: #fff !important;
    }
  }
}
</style>
